var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({class:{ 'right-align': !_vm.alignLeft },attrs:{"type":"number"},model:{value:(_vm._value),callback:function ($$v) {_vm._value=_vm._n($$v)},expression:"_value"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }